import { connect } from 'react-redux'
import { loadImagesForJob, markImageIgnored, markImageLabeled } from '../../../store/jobs'
import ImageView from '../components/ImageView'
import { isUserStaff, isUserProvider } from '../../../lib/helpers'

const mapDispatchToProps = {
  loadImagesForJob,
  markImageLabeled,
  markImageIgnored
}

const mapStateToProps = (state, ownProps) => ({
  job: state.jobs[ownProps.params.jobId],
  isStaff: isUserStaff(state.user),
  isProvider: isUserProvider(state.user)
})

export default connect(mapStateToProps, mapDispatchToProps)(ImageView)



// WEBPACK FOOTER //
// ./src/routes/Images/containers/ImageContainer.js